export default __webpack_public_path__ + "static/media/mg.bdd56d44.svg";